/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_2_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_2_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_2_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported in applicable desktop editions; not executed in Excel for the web.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_2_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_2_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用的桌面版本支持；Excel 网页版不执行 VBA。`)
};

/**
* | output |
* | --- |
* | "Supported in applicable desktop editions; not executed in Excel for the web." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_2_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_2_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_2_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_2_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_2_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_2_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_2_2 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.2.2" }